import { render, staticRenderFns } from "./OrgTranslationEditor.vue?vue&type=template&id=5a89d4be&"
import script from "./OrgTranslationEditor.vue?vue&type=script&lang=js&"
export * from "./OrgTranslationEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports